import React from "react";
import Breadcrumb from "../components/Breadcrumb";
import MembershipPaymentLAyer from "../components/MembershipPaymentLayer"


const MembershipPaymentListPage = () => {
  return (
    <>

      

        {/* Breadcrumb */}
        {/* <Breadcrumb title="Users Grid" /> */}
        <div className="d-flex justify-content-between"><h5>Membership Payments</h5><Breadcrumb title="Membership Payments" /></div>
        {/* UsersListLayer */}
        <MembershipPaymentLAyer/>
      
    </>
  );
};

export default MembershipPaymentListPage; 
